import type { AudioQualityTimelineTableProps } from './audioQuality.types';
import { formatDay, formatNumber } from './formatting';

export const AudioQualityTimelineTable = ({ points }: AudioQualityTimelineTableProps) => (
  <details className="rounded-md border p-4 text-sm">
    <summary className="cursor-pointer font-medium">Fjöldi upptaka eftir tímabili</summary>
    <div className="mt-3 max-h-64 overflow-auto">
      <table className="w-full text-left tabular-nums">
        <caption className="sr-only">Fjöldi skráðra, metinna og ómetinna upptaka eftir tímabili</caption>
        <thead>
          <tr>
            <th scope="col">Tímabil</th>
            <th scope="col">Skráðar</th>
            <th scope="col">Metnar</th>
            <th scope="col">Ómetnar</th>
            <th scope="col">Mati ólokið</th>
          </tr>
        </thead>
        <tbody>
          {points.map((point) => (
            <tr key={point.date}>
              <th scope="row">{formatDay(point.date)}</th>
              <td>{formatNumber(point.totalRecordings)}</td>
              <td>{formatNumber(point.assessedRecordings)}</td>
              <td>{formatNumber(point.unknownRecordings)}</td>
              <td>{formatNumber(point.partialRecordings)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </details>
);
